import './OurClients.css'
import Marquee from "react-fast-marquee";
import partner1 from '../../../assets/images/partners/partner1.webp'
import partner2 from '../../../assets/images/partners/partner2.webp'
import partner3 from '../../../assets/images/partners/partner3.webp'
import partner4 from '../../../assets/images/partners/partner4.webp'
import partner5 from '../../../assets/images/partners/partner5.webp'
import partner6 from '../../../assets/images/partners/partner6.webp'
import partner7 from '../../../assets/images/partners/partner7.webp'

const tickerImagesArr = [
    partner1,
    partner2,
    partner3,
    partner4,
    partner5,
    partner6,
    partner7,
]

const OurClients = () => {
    return (
      <div className='main__ticker-wrapper'>
          <h2 className="main__ticker-title mont-m">Партнеры, с которыми мы работали</h2>
         <Marquee className='marquee' loop={0}>
     {
      tickerImagesArr.map((img, idx) => {
          return (
              <img key={idx} src={img} alt="фото партнерів ТОВ Агролада" className="main__ticker-image" />
          )
      })
     }
    </Marquee>
      </div>
    )
  }
  
  export default OurClients